import React, { createContext, useContext, useEffect, useState } from "react";

// A page's primary mobile action (rendered as a circle button at the right of the
// bottom nav row). Pages register it via useMobileAction; BottomNav renders it.
export type MobileAction = {
  icon: React.ReactNode;
  onClick: () => void;
  label: string;
} | null;

const MobileActionContext = createContext<{
  action: MobileAction;
  setAction: React.Dispatch<React.SetStateAction<MobileAction>>;
}>({ action: null, setAction: () => {} });

export const MobileActionProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [action, setAction] = useState<MobileAction>(null);
  return (
    <MobileActionContext.Provider value={{ action, setAction }}>
      {children}
    </MobileActionContext.Provider>
  );
};

export const useMobileActionSlot = () => useContext(MobileActionContext).action;

// Pages register their primary mobile action here; cleared on unmount.
export const useMobileAction = (
  action: MobileAction,
  deps: React.DependencyList,
) => {
  const { setAction } = useContext(MobileActionContext);
  useEffect(() => {
    setAction(action);
    return () => setAction(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
